import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Categories from "./components/Categories";
import CategoryDetail from "./components/CategoryDetail";
import ProDetail from "./components/ProDetail";
import About from "./components/About";
import Contact from "./components/Contact";
import Avantages from "./components/Avantages";
import Blog from "./components/Blog";
import BlogArticle from "./components/BlogArticle";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <Helmet>
          <title>E-Shops SEO | Solutions Digitales pour Commerces</title>
          <meta name="description" content="Solutions digitales sur mesure pour les commerces de proximité. SEO local, automatisation, applications métier." />
        </Helmet>
        
        <Header />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categorie/:slug" element={<CategoryDetail />} />
            <Route path="/pro/:slug" element={<ProDetail />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/avantages" element={<Avantages />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
